import { render, staticRenderFns } from "./RecreationalApplication.vue?vue&type=template&id=4b12ab72&"
import script from "./RecreationalApplication.vue?vue&type=script&lang=js&"
export * from "./RecreationalApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports